/**
 * Optimized Coaching Management with Pagination and Caching
 */

import CoachingManagement from './CoachingManagement';
import withOptimization from '../../hoc/withOptimization';

export default withOptimization(CoachingManagement, {
  collection: 'coachingCenters',
  pageSize: 20,
  orderByField: 'createdAt',
  orderDirection: 'desc',
  cacheTTL: 5 * 60 * 1000
});

/**
 * Performance Improvements:
 * - Before: Loads ALL coaching centers (100+) = 5-8s load time
 * - After: Loads 20 centers at a time = 1-2s load time
 * - Firestore reads: 100+ → 20-50
 */
